import React, { useEffect, useState } from 'react'

const PapCaptureApiShowResponse: React.FC<{
  row: string
}> = ({ row }) => {
  const [parsedResponse, setParsedResponse] = useState<string | null>(null)

  const setParsedDataMethod = () => {
    try {
      const parsedResponse = typeof row === 'string' ? JSON.parse(row) : row
      setParsedResponse(parsedResponse)
    } catch {
      setParsedResponse(row)
    }
  }

  useEffect(() => {
    if (row) setParsedDataMethod()
  }, [row])
  return (
    <div className="h-full max-h-[50vh] overflow-auto">
      <pre className="bg-gray-50 text-gray-800 p-4 rounded-lg border border-gray-200 text-sm font-mono whitespace-pre-wrap break-all">
        {JSON.stringify(parsedResponse, null, 2)}
      </pre>
    </div>
  )
}

export default PapCaptureApiShowResponse
